// logo
export const EyeIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="36"
    viewBox="0 0 54 36"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66645 19.3256C2.82534 19.1357 2.90479 19.0407 2.88932 18.9375C2.87384 18.8344 2.77083 18.7677 2.5648 18.6343L1.16239 17.7265C0.974028 17.6046 0.879848 17.5437 0.861279 17.4467C0.84271 17.3497 0.906855 17.259 1.03514 17.0777C4.67299 11.9348 11.3093 4.81074 20.3514 1.63342C25.0613 -0.0215818 30.4046 -0.594678 36.1957 0.741731C41.8515 2.04693 47.7293 5.12516 53.7435 10.4441C53.9117 10.5929 53.9958 10.6673 53.9999 10.766C54.0039 10.8647 53.9259 10.9459 53.77 11.1083L50.3276 14.6943C50.1714 14.8571 50.0933 14.9384 50.0967 15.0364C50.1002 15.1344 50.1843 15.2104 50.3526 15.3626C50.8177 15.783 51.2834 16.2186 51.7497 16.6697L52.9061 17.7884C53.034 17.9122 53.098 17.974 53.1082 18.0547C53.1185 18.1355 53.0719 18.2117 52.9788 18.3641C52.9289 18.4458 52.879 18.5276 52.8292 18.6093L52.829 18.6095C52.5773 19.0223 52.3254 19.435 52.0669 19.8438C52.0224 19.9136 51.9593 20.0113 51.8778 20.134C51.7149 20.3795 51.4784 20.726 51.1707 21.1515C50.5561 22.0014 49.6531 23.1725 48.4809 24.4863C46.1508 27.0978 42.6845 30.3549 38.2266 32.7382C33.7404 35.1367 28.1985 36.6729 21.848 35.7075C15.5101 34.744 8.67093 31.3352 1.48765 24.386L0.217068 23.1568C0.0772856 23.0216 0.00739444 22.9539 0.000540229 22.8665C-0.00631399 22.7791 0.0521746 22.7013 0.169152 22.5457L1.22454 21.1418C1.66068 20.5617 2.14184 19.9527 2.66645 19.3256ZM7.07548 22.0238C6.93757 22.184 6.86861 22.2641 6.87519 22.3592C6.88177 22.4542 6.96172 22.5245 7.12163 22.665C12.9468 27.7842 18.1639 30.0768 22.6518 30.7591C27.6278 31.5156 32.0102 30.3385 35.7222 28.354C39.4626 26.3543 42.4686 23.5587 44.5613 21.2132C45.2476 20.444 45.8279 19.732 46.2959 19.1254C46.4189 18.9661 46.4804 18.8864 46.4715 18.795C46.4627 18.7036 46.3866 18.637 46.2345 18.5039C41.783 14.6086 37.6122 12.4331 33.8121 11.4091C32.7654 11.127 31.7375 10.9297 30.7293 10.8088C30.6399 10.7981 30.5953 10.7928 30.5501 10.8062C30.5049 10.8196 30.4726 10.8464 30.4081 10.9002C29.673 11.5126 29.2076 12.4195 29.2076 13.4316C29.2076 15.276 30.7531 16.7711 32.6595 16.7711C33.1265 16.7711 33.5718 16.6814 33.9781 16.5188C34.054 16.4884 34.092 16.4732 34.1138 16.4691C34.2427 16.4447 34.3561 16.5221 34.3813 16.6517C34.3855 16.6736 34.3855 16.7061 34.3855 16.7711C34.3855 21.3819 30.5219 25.1196 25.7558 25.1196C20.9897 25.1196 17.126 21.3819 17.126 16.7711C17.126 15.9973 17.2348 15.2481 17.4384 14.537C17.5983 13.979 17.6782 13.7 17.5573 13.6039C17.4364 13.5078 17.2005 13.6419 16.7287 13.9099C12.8025 16.1404 9.50824 19.1983 7.07548 22.0238Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// password
export const CloseEyeIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50677 10.6107C2.64773 10.4335 2.61003 10.1718 2.42059 10.0478C2.24399 9.93215 2.19632 9.69388 2.32018 9.52294C3.4447 7.97109 5.39585 5.93017 8.0157 4.99895C9.43832 4.49329 11.0523 4.31823 12.8015 4.72666C14.3303 5.08362 15.9128 5.87446 17.5305 7.20158C17.8002 7.42284 17.9351 7.53347 17.9766 7.68903C17.9932 7.75116 17.9976 7.82207 17.9889 7.88578C17.967 8.04529 17.8419 8.17711 17.5918 8.44074L17.4699 8.56923C17.3322 8.7143 17.2634 8.78684 17.229 8.86034C17.1616 9.00444 17.1645 9.15905 17.2371 9.30056C17.2742 9.37274 17.3493 9.44625 17.4995 9.59327L17.7859 9.8735C17.87 9.95581 17.8863 10.0853 17.8255 10.186C17.7495 10.3122 17.6734 10.4383 17.5953 10.5632C17.5819 10.5845 17.5628 10.6144 17.5382 10.6519C17.489 10.7269 17.4176 10.8328 17.3246 10.9628C17.139 11.2225 16.8662 11.5803 16.5122 11.9818C15.8084 12.7798 14.7614 13.7751 13.4148 14.5033C12.0597 15.2362 10.3858 15.7057 8.4676 15.4106C6.55322 15.1162 4.48743 14.0746 2.31769 11.9511C2.16657 11.8032 2.09101 11.7293 2.05243 11.6452C2.00299 11.5375 1.99341 11.4158 2.02539 11.3017C2.05035 11.2126 2.11297 11.1284 2.23822 10.9598C2.32224 10.8468 2.4118 10.7301 2.50677 10.6107ZM8.71039 13.8986C7.51868 13.7153 6.15675 13.1517 4.64946 11.9554C4.30018 11.6781 4.12553 11.5395 4.11112 11.3182C4.09672 11.097 4.2508 10.938 4.55898 10.6201C5.56527 9.58202 6.91208 8.54983 8.4852 8.05717C9.5767 7.71534 10.7807 7.63121 12.0814 7.98579C13.0571 8.25177 14.1137 8.77197 15.2345 9.65307C15.5671 9.91459 15.7335 10.0454 15.7534 10.2593C15.7733 10.4732 15.6349 10.6314 15.3581 10.9476C15.3482 10.9589 15.3383 10.9703 15.3282 10.9816C14.6961 11.6983 13.7882 12.5526 12.6584 13.1636C11.5371 13.7701 10.2134 14.1297 8.71039 13.8986Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const OpenEyeIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50677 10.6107C2.64773 10.4335 2.61003 10.1718 2.42059 10.0478C2.24399 9.93215 2.19632 9.69388 2.32018 9.52294C3.4447 7.97109 5.39585 5.93017 8.0157 4.99895C9.43832 4.49329 11.0523 4.31823 12.8015 4.72666C14.3303 5.08362 15.9128 5.87446 17.5305 7.20158C17.8002 7.42284 17.9351 7.53347 17.9766 7.68903C17.9932 7.75116 17.9976 7.82207 17.9889 7.88578C17.967 8.04529 17.8419 8.17711 17.5918 8.44074L17.4699 8.56923C17.3322 8.7143 17.2634 8.78684 17.229 8.86034C17.1616 9.00444 17.1645 9.15905 17.2371 9.30056C17.2742 9.37274 17.3493 9.44625 17.4995 9.59327L17.7859 9.87355C17.87 9.95584 17.8863 10.0852 17.8256 10.186L17.8255 10.186C17.7495 10.3122 17.6734 10.4383 17.5953 10.5632C17.5819 10.5845 17.5628 10.6144 17.5382 10.6519C17.489 10.7269 17.4176 10.8328 17.3246 10.9628C17.139 11.2225 16.8662 11.5803 16.5122 11.9818C15.8084 12.7798 14.7614 13.7751 13.4148 14.5033C12.0597 15.2362 10.3858 15.7057 8.4676 15.4106C6.55322 15.1162 4.48743 14.0746 2.31769 11.9511C2.16657 11.8032 2.09101 11.7293 2.05243 11.6452C2.00299 11.5375 1.99341 11.4158 2.02539 11.3017C2.05035 11.2126 2.11297 11.1284 2.23822 10.9598C2.32224 10.8468 2.4118 10.7301 2.50677 10.6107ZM4.55889 10.6202C4.25077 10.938 4.09672 11.097 4.11113 11.3182C4.12554 11.5395 4.30018 11.6781 4.64946 11.9554C6.15675 13.1517 7.51868 13.7153 8.71039 13.8986C10.2134 14.1297 11.5371 13.7701 12.6584 13.1636C13.7882 12.5526 14.6961 11.6983 15.3282 10.9816C15.3383 10.9703 15.3482 10.9589 15.3581 10.9476C15.6349 10.6314 15.7733 10.4732 15.7534 10.2593C15.7335 10.0454 15.5671 9.91459 15.2345 9.65307C14.1137 8.77197 13.0571 8.25177 12.0814 7.98579C11.8824 7.93154 11.6857 7.88756 11.4913 7.85321C11.303 7.81993 11.2089 7.8033 11.0671 7.86836C10.9252 7.93342 10.8939 7.98621 10.8312 8.0918C10.7419 8.24225 10.6908 8.4171 10.6908 8.60364C10.6908 9.1672 11.1576 9.62406 11.7334 9.62406C11.8738 9.62406 12.0077 9.59691 12.13 9.54768C12.1875 9.52452 12.2548 9.56205 12.2548 9.62406C12.2548 11.033 11.0878 12.1751 9.64814 12.1751C8.20852 12.1751 7.04148 11.033 7.04148 9.62406C7.04148 9.2654 6.62857 8.9178 6.33168 9.11904C5.66353 9.57193 5.06768 10.0953 4.55889 10.6202Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// date input
export const DateIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9998 4C5.88935 4 5.7998 4.08954 5.7998 4.2V5H3.6C3.26863 5 3 5.26863 3 5.6V6.90557C3 6.96767 3.01446 7.02892 3.04223 7.08446L3.47764 7.95528C3.49172 7.98343 3.49172 8.01657 3.47764 8.04472L3.04223 8.91554C3.01446 8.97108 3 9.03233 3 9.09443V15.6C3 16.3732 3.6268 17 4.4 17H15.6C16.3732 17 17 16.3732 17 15.6V9.09443C17 9.03233 16.9855 8.97108 16.9578 8.91554L16.5224 8.04472C16.5083 8.01657 16.5083 7.98343 16.5224 7.95528L16.9578 7.08446C16.9855 7.02892 17 6.96767 17 6.90557V5.6C17 5.26863 16.7314 5 16.4 5H14.1998V4.2C14.1998 4.08954 14.1103 4 13.9998 4H12.9998C12.8893 4 12.7998 4.08954 12.7998 4.2V5H10.6998V4.2C10.6998 4.08954 10.6103 4 10.4998 4H9.4998C9.38935 4 9.2998 4.08954 9.2998 4.2V5H7.1998V4.2C7.1998 4.08954 7.11026 4 6.9998 4H5.9998ZM5.7998 6.4V6.8C5.7998 6.91046 5.88935 7 5.9998 7H6.9998C7.11026 7 7.1998 6.91046 7.1998 6.8V6.4H9.2998V6.8C9.2998 6.91046 9.38935 7 9.4998 7H10.4998C10.6103 7 10.6998 6.91046 10.6998 6.8V6.4H12.7998V6.8C12.7998 6.91046 12.8893 7 12.9998 7H13.9998C14.1103 7 14.1998 6.91046 14.1998 6.8V6.4H15.6V6.6695L15.2702 7.32918C15.059 7.75147 15.059 8.24853 15.2702 8.67082L15.4379 9.00625L4.56212 9.00625L4.72984 8.67082C4.94098 8.24853 4.94098 7.75147 4.72984 7.32918L4.4 6.66951V6.4H5.7998ZM4.4 10.4062L4.4 15.6H15.6V10.4062H4.4ZM10 11L10.0974 11.2305C10.4157 11.9843 11.0156 12.5842 11.7695 12.9026L12 13L11.7695 13.0974C11.0156 13.4158 10.4157 14.0157 10.0974 14.7695L10 15L9.90262 14.7695C9.58426 14.0157 8.98438 13.4158 8.23047 13.0974L8 13L8.23047 12.9026C8.98438 12.5842 9.58426 11.9843 9.90262 11.2305L10 11Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// likes
export const HeartIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2023 0.688843C3.14685 0.688843 0.466797 2.9067 0.466797 5.88529C0.466797 7.10219 0.748106 8.09442 1.27665 8.97992C1.78989 9.83979 2.51066 10.5537 3.30239 11.251C3.64368 11.5515 4.00433 11.8548 4.38275 12.1731L4.38276 12.1731C5.78589 13.3531 7.43325 14.7384 9.24315 16.9522L10.0001 17.8781L10.7571 16.9522C12.567 14.7384 14.2144 13.3531 15.6175 12.1731L15.6175 12.1731L15.6176 12.173C15.996 11.8548 16.3566 11.5515 16.6979 11.251C17.4896 10.5537 18.2104 9.83979 18.7236 8.97992C19.2522 8.09442 19.5335 7.10219 19.5335 5.88529C19.5335 2.9067 16.8534 0.688843 13.798 0.688843C12.3854 0.688843 11.0346 1.1534 10.0001 1.94625C8.9657 1.1534 7.61485 0.688843 6.2023 0.688843ZM3.83381 3.35844C2.95506 3.97058 2.42235 4.90641 2.42235 5.88529C2.42235 6.77156 2.61925 7.41376 2.95583 7.97765C3.30771 8.56718 3.83897 9.11768 4.59489 9.78343C4.89736 10.0498 5.23094 10.33 5.5909 10.6324L5.59101 10.6325C6.81698 11.6623 8.34891 12.9491 10.0001 14.8226C11.6513 12.9491 13.1833 11.6623 14.4092 10.6325C14.7692 10.3301 15.1029 10.0499 15.4054 9.78343C16.1613 9.11768 16.6926 8.56718 17.0444 7.97765C17.381 7.41376 17.5779 6.77156 17.5779 5.88529C17.5779 4.20114 16.0011 2.6444 13.798 2.6444C12.5389 2.6444 11.4052 3.17017 10.7271 3.92405L10.0001 4.73241L9.99153 4.72284C9.99178 4.72433 9.99203 4.72582 9.99228 4.72731C9.49537 4.56334 8.9327 4.69426 8.5731 5.10521C8.09032 5.65695 8.1564 6.50452 8.72071 6.99831C8.90539 7.15991 9.12055 7.26359 9.34338 7.31061C9.30753 7.35626 9.27028 7.40119 9.23163 7.44537C8.02466 8.82472 5.90255 8.94217 4.49178 7.70771C3.20617 6.58277 2.9549 4.72335 3.83381 3.35844Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// bookmarks
export const FillBookmarkIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.81638 2.27767C1.95452 1.1933 2.02359 0.651117 2.40457 0.325559C2.78556 0 3.35098 0 4.48183 0H11.1896C12.6051 0 13.3128 0 13.7136 0.437827C14.1144 0.875653 14.028 1.55429 13.8551 2.91156L12.1458 16.3289C12.0929 16.7449 12.0664 16.9528 11.927 16.9937C11.7877 17.0345 11.646 16.8759 11.3627 16.5585L6.86013 11.5158C6.74586 11.3878 6.68873 11.3238 6.61262 11.3198C6.53651 11.3158 6.47257 11.3735 6.34468 11.4888L0.803031 16.4859C0.426617 16.8253 0.238411 16.995 0.0987271 16.9263C-0.0409566 16.8575 -0.00950841 16.6107 0.0533879 16.1169L1.81638 2.27767Z"
      fill="var(--neutral-contrast-active)"
    />
  </svg>
);

export const StrokeBookmarkIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59483 3.34952C2.79217 1.75486 2.89084 0.957526 3.43511 0.478763C3.97937 0 4.78712 0 6.40262 0H15.9852C18.0073 0 19.0183 0 19.5909 0.643863C20.1635 1.28773 20.04 2.28572 19.793 4.28171L17.3512 24.0131C17.2755 24.6248 17.2377 24.9306 17.0386 24.9907C16.8395 25.0508 16.6372 24.8175 16.2324 24.3508L9.80019 16.935C9.63695 16.7468 9.55533 16.6527 9.4466 16.6468C9.33787 16.641 9.24652 16.7258 9.06382 16.8953L1.14719 24.244C0.609454 24.7431 0.340587 24.9927 0.141039 24.8916C-0.0585094 24.7905 -0.0135834 24.4274 0.0762685 23.7014L2.59483 3.34952ZM4.1088 17.1454L6.88239 14.5708C6.88239 14.5708 6.88702 14.5665 6.89103 14.5627C6.94279 14.5137 7.17871 14.2907 7.43748 14.1088C7.79207 13.8595 8.55517 13.4145 9.61927 13.4718M4.1088 17.1454L5.76798 3.73794C5.794 3.52772 5.81673 3.34447 5.83792 3.18064C6.004 3.17973 6.18965 3.17968 6.40262 3.17968H15.9852C16.2557 3.17968 16.4932 3.17974 16.7066 3.18105C16.6818 3.3918 16.6529 3.62626 16.6198 3.8933L14.8831 17.9272L12.221 14.858C12.221 14.858 12.2169 14.8532 12.2133 14.849C12.1671 14.7948 11.9568 14.5478 11.7193 14.3392C11.3938 14.0533 10.6834 13.529 9.61927 13.4718"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const SearchIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5453 7.5453C9.60571 5.4849 12.9463 5.4849 15.0067 7.5453C17.0457 9.58434 17.0669 12.8771 15.0701 14.9422C15.0474 14.9612 15.0252 14.9815 15.0038 15.0029C14.9824 15.0243 14.9621 15.0465 14.943 15.0693C12.878 17.0669 9.58462 17.046 7.5453 15.0067C5.4849 12.9463 5.4849 9.60571 7.5453 7.5453ZM15.6662 17.0794C12.8147 19.2421 8.73282 19.0226 6.13109 16.4209C3.28964 13.5794 3.28964 8.97255 6.13109 6.13109C8.97255 3.28964 13.5794 3.28964 16.4209 6.13109C19.0223 8.73249 19.2421 12.8136 17.0802 15.665L19.708 18.2929C20.0986 18.6834 20.0986 19.3165 19.708 19.7071C19.3175 20.0976 18.6844 20.0976 18.2938 19.7071L15.6662 17.0794Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// for creaters
export const PenIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="21"
    viewBox="0 0 14 21"
    fill="none"
  >
    <g clipPath="url(#clip0_116_5145)">
      <path
        className={fillClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.35353 14.5049L6.39141 4.44954C8.26939 4.90022 9.978 5.88666 11.3073 7.28767L5.11803 16.6783C4.74733 17.2408 4.56197 17.522 4.33464 17.7687C4.10731 18.0154 3.84191 18.2232 3.31111 18.639L2.01061 19.6576C1.14274 20.3373 0.708813 20.6772 0.401924 20.5C0.0950344 20.3228 0.172405 19.7771 0.327147 18.6856L0.55903 17.0501C0.653672 16.3825 0.700993 16.0487 0.80095 15.7285C0.900908 15.4083 1.05178 15.1072 1.35353 14.5049ZM3.87997 13.9239C3.93175 13.9467 3.99522 13.9834 4.12217 14.0567C4.24912 14.13 4.3126 14.1666 4.3583 14.2C4.85017 14.5594 4.93385 15.2581 4.5401 15.7179C4.50351 15.7606 4.45039 15.8105 4.34417 15.9102L3.71427 16.5017C2.96746 17.2029 2.59405 17.5536 2.33328 17.5047C2.21545 17.4826 2.10857 17.4209 2.03054 17.3299C1.85785 17.1285 1.9748 16.6298 2.20868 15.6324L2.40596 14.7912C2.43923 14.6493 2.45586 14.5784 2.47457 14.5254C2.67589 13.9544 3.32284 13.6776 3.87997 13.9239Z"
        fill="var(--neutral-contrast-active)"
      />
      <path
        className={fillClassName}
        d="M12.4046 5.62282C12.87 4.91668 13.1027 4.56361 13.1881 4.21936C13.3505 3.56433 13.1836 2.86969 12.7406 2.35589C12.5077 2.08587 12.1391 1.87306 11.4019 1.44744C10.6647 1.02182 10.2961 0.809014 9.94586 0.742367C9.27936 0.61555 8.59438 0.818407 8.1083 1.28656C7.85284 1.53259 7.66343 1.91065 7.2846 2.66677L6.84994 3.53433C8.77261 3.98288 10.5208 4.99219 11.8707 6.43296L12.4046 5.62282Z"
        fill="var(--neutral-contrast-active)"
      />
    </g>
    <defs>
      <clipPath id="clip0_116_5145">
        <rect
          className={fillClassName}
          width="14"
          height="21"
          fill="var(--neutral-contrast-active)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FireIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="40"
    viewBox="0 0 30 40"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M12.011 40C12.011 40 4.70576 39.4474 1.2082 32.9535C-2.28889 26.4593 2.91804 18.5835 2.91804 18.5835C2.91804 18.5835 2.14088 26.0447 7.58145 26.3902C13.022 26.7358 15.4311 21.4851 11.3894 15.5438C7.34804 9.60267 9.67001 1.5887 17.4467 0C17.4467 0 12.711 6.83918 19.6277 11.6063C26.5447 16.373 31.5187 23.3507 29.5757 29.9138C27.6325 36.4767 18.928 39.5164 18.928 39.5164C18.928 39.5164 25.4058 35.2807 20.7421 26.1152C20.7421 26.1152 20.2584 29.9882 15.8194 31.1809C11.8409 32.2498 7.32371 35.9231 12.0108 40H12.011Z"
      fill="var(--neutral-contrast-active)"
    />
  </svg>
);

export const FeatherIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M10.8496 4.24648C10.8496 4.24648 11.0982 5.6746 11.0369 6.77504C10.8567 5.08859 10.0779 3.4491 8.70532 2.16637C6.55751 0.160075 3.51076 -0.450537 0.815104 0.325589C4.64887 0.61412 3.63565 4.05972 5.92837 5.94076C5.3652 5.54375 4.59232 5.4677 4.59232 5.4677C6.04029 6.82313 6.39964 8.29598 6.4503 9.45234C6.4774 10.0764 6.41377 10.7004 6.27239 11.3099C5.99317 12.5177 5.4842 13.6886 4.74313 14.7577C4.85977 14.656 4.97405 14.5508 5.08715 14.4424C8.34008 11.3043 8.73359 6.50999 6.29124 2.97157C6.57636 3.3205 6.83203 3.68396 7.05706 4.05972C7.05706 4.05972 7.05706 4.06083 7.05823 4.06195C9.1436 7.54222 8.64405 12.0469 5.53839 15.0418C3.76524 16.7517 2.4292 17.1364 0.0893502 17.246C0.012769 17.2494 -0.0272888 17.3344 0.0210162 17.3903C0.244869 17.6531 0.521739 17.8186 0.731454 17.9148C0.924674 18.0043 1.14499 18.0233 1.35353 17.9718C2.88515 17.5927 4.31309 16.5202 5.59612 15.7061C7.11832 15.4187 8.72535 14.6202 9.85404 13.4716C12.2304 11.0527 12.737 7.1083 10.8496 4.24648Z"
      fill="var(--neutral-contrast-active)"
    />
  </svg>
);

export const BurgerIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      className={fillClassName}
      width="16"
      height="2"
      rx="1"
      fill="var(--neutral-active)"
    />
    <rect
      className={fillClassName}
      y="6"
      width="16"
      height="2"
      rx="1"
      fill="var(--neutral-active)"
    />
    <rect
      className={fillClassName}
      y="12"
      width="16"
      height="2"
      rx="1"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const CloseIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M0.403351 19.5963C0.221326 19.4224 0.101355 19.2153 0.0434378 18.9752C-0.0144793 18.735 -0.0144793 18.4948 0.0434378 18.2547C0.109629 18.0145 0.2296 17.8116 0.403351 17.646L8.02358 9.99379L0.403351 2.35404C0.2296 2.18841 0.113766 1.98551 0.0558486 1.74534C-0.00206847 1.50518 -0.00206847 1.26501 0.0558486 1.02484C0.113766 0.784679 0.2296 0.57764 0.403351 0.403727C0.585376 0.221532 0.796359 0.101449 1.0363 0.0434783C1.27624 -0.0144928 1.51619 -0.0144928 1.75613 0.0434783C1.99607 0.101449 2.20292 0.217391 2.37667 0.391304L10.0093 8.03106L17.6295 0.391304C17.8033 0.20911 18.0101 0.0931677 18.2501 0.0434783C18.49 -0.0144928 18.7258 -0.0144928 18.9575 0.0434783C19.1974 0.101449 19.4126 0.221532 19.6029 0.403727C19.7766 0.57764 19.8924 0.784679 19.9504 1.02484C20.0165 1.26501 20.0165 1.50518 19.9504 1.74534C19.8924 1.97723 19.7766 2.18427 19.6029 2.36646L11.9826 9.99379L19.6029 17.6335C19.7766 17.8157 19.8924 18.0269 19.9504 18.2671C20.0083 18.499 20.0083 18.735 19.9504 18.9752C19.8924 19.2153 19.7766 19.4224 19.6029 19.5963C19.4208 19.7785 19.2098 19.8986 18.9699 19.9565C18.73 20.0145 18.49 20.0145 18.2501 19.9565C18.0101 19.8986 17.8033 19.7826 17.6295 19.6087L10.0093 11.9689L2.37667 19.6087C2.20292 19.7826 1.99607 19.8986 1.75613 19.9565C1.52446 20.0145 1.28452 20.0145 1.0363 19.9565C0.796359 19.8986 0.585376 19.7785 0.403351 19.5963Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const PlusInCircleIcon = ({
  mainClassName,
  fillClassName,
  strokeClassName,
}) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <rect
      className={fillClassName}
      width="18"
      height="18"
      rx="9"
      fill="var(--second-active-tertiary)"
    />
    <path
      className={strokeClassName}
      d="M9 5V13"
      stroke="var(--neutral-contrast-active)"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M5 9L13 9"
      stroke="var(--neutral-contrast-active)"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// different kinds of arrows for dropdowns, swiper navigation, links, etc.
export const TriangleArrowIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M7.02918 0H0.97082C0.524791 0 0.234694 0.469387 0.434164 0.868328L3.46334 6.92669C3.68446 7.36892 4.31554 7.36892 4.53666 6.92669L7.56584 0.868328C7.76531 0.469388 7.47521 0 7.02918 0Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const AngleArrowIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    width="11"
    height="20"
    viewBox="0 0 11 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={fillClassName}
      d="M10.6279 10.2441C10.6279 10.3802 10.5993 10.5091 10.542 10.6309C10.4919 10.7454 10.4167 10.8529 10.3164 10.9531L1.80859 19.2783C1.61523 19.4717 1.37891 19.5684 1.09961 19.5684C0.920573 19.5684 0.755859 19.5254 0.605469 19.4395C0.455078 19.3535 0.336914 19.2354 0.250977 19.085C0.165039 18.9417 0.12207 18.777 0.12207 18.5908C0.12207 18.3258 0.215169 18.0931 0.401367 17.8926L8.22168 10.2441L0.401367 2.5957C0.215169 2.39518 0.12207 2.16243 0.12207 1.89746C0.12207 1.71126 0.165039 1.54655 0.250977 1.40332C0.336914 1.25293 0.455078 1.13477 0.605469 1.04883C0.755859 0.962891 0.920573 0.919922 1.09961 0.919922C1.37891 0.919922 1.61523 1.01302 1.80859 1.19922L10.3164 9.53516C10.4167 9.63542 10.4919 9.74642 10.542 9.86816C10.5993 9.98275 10.6279 10.1081 10.6279 10.2441Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const ArrowInCircleIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M24.9873 50C21.5536 50 18.324 49.3452 15.2983 48.0357C12.2896 46.7432 9.63794 44.949 7.34319 42.6531C5.04844 40.3571 3.24664 37.7041 1.93779 34.6939C0.645929 31.6667 0 28.4354 0 25C0 21.5646 0.645929 18.3418 1.93779 15.3316C3.24664 12.3044 5.04844 9.64286 7.34319 7.34694C9.63794 5.05102 12.2896 3.2568 15.2983 1.96429C18.324 0.654762 21.5536 0 24.9873 0C28.4209 0 31.642 0.654762 34.6507 1.96429C37.6764 3.2568 40.3366 5.05102 42.6313 7.34694C44.9261 9.64286 46.7279 12.3044 48.0367 15.3316C49.3456 18.3418 50 21.5646 50 25C50 28.4354 49.3456 31.6667 48.0367 34.6939C46.7279 37.7041 44.9261 40.3571 42.6313 42.6531C40.3366 44.949 37.6849 46.7432 34.6762 48.0357C31.6675 49.3452 28.4379 50 24.9873 50ZM24.9873 48.0612C28.1829 48.0612 31.1746 47.466 33.9623 46.2755C36.75 45.085 39.1977 43.4354 41.3055 41.3265C43.4302 39.2007 45.0875 36.7432 46.2774 33.9541C47.4673 31.165 48.0622 28.1803 48.0622 25C48.0622 21.8197 47.4673 18.835 46.2774 16.0459C45.0875 13.2568 43.4302 10.7993 41.3055 8.67347C39.1977 6.54762 36.75 4.88946 33.9623 3.69898C31.1746 2.5085 28.1829 1.91327 24.9873 1.91327C21.8086 1.91327 18.8254 2.5085 16.0377 3.69898C13.25 4.88946 10.7938 6.54762 8.66905 8.67347C6.56128 10.7993 4.91246 13.2568 3.72259 16.0459C2.53272 18.835 1.93779 21.8197 1.93779 25C1.93779 28.1803 2.53272 31.165 3.72259 33.9541C4.91246 36.7432 6.56128 39.2007 8.66905 41.3265C10.7938 43.4354 13.25 45.085 16.0377 46.2755C18.8254 47.466 21.8086 48.0612 24.9873 48.0612ZM38.1183 24.949C38.1183 25.2041 38.0163 25.4337 37.8123 25.6378L28.0979 35.3316C27.9109 35.5357 27.69 35.6378 27.435 35.6378C27.197 35.6378 26.993 35.5527 26.823 35.3827C26.6701 35.2126 26.5936 35.0085 26.5936 34.7704C26.5936 34.5153 26.7041 34.2857 26.925 34.0816L31.999 29.0051L35.2371 25.7908L31.4635 25.9184H12.7996C12.5106 25.9184 12.2811 25.8333 12.1112 25.6633C11.9412 25.4762 11.8562 25.2551 11.8562 25C11.8562 24.6939 11.9412 24.4558 12.1112 24.2857C12.2981 24.1156 12.5276 24.0306 12.7996 24.0306H31.4635L35.2626 24.1582L31.999 20.9439L26.925 15.8673C26.7041 15.6463 26.5936 15.4082 26.5936 15.1531C26.5936 14.932 26.6701 14.7364 26.823 14.5663C26.993 14.3963 27.197 14.3112 27.435 14.3112C27.707 14.3112 27.9279 14.4133 28.0979 14.6173L37.8123 24.2857C38.0163 24.5068 38.1183 24.7279 38.1183 24.949Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

export const TopArrowIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={fillClassName}
      d="M6 14.6797C5.84896 14.6797 5.72396 14.6302 5.625 14.5312C5.53125 14.4375 5.48437 14.3151 5.48437 14.1641L5.48438 3.28906L5.53906 1.17188L5.84375 1.28125L3.4375 3.86719L1.04687 6.23438C1.00521 6.28125 0.950521 6.31771 0.882812 6.34375C0.820312 6.36458 0.752604 6.375 0.679687 6.375C0.539062 6.375 0.419271 6.32812 0.320312 6.23438C0.226562 6.13542 0.179687 6.01302 0.179687 5.86719C0.179687 5.72656 0.234375 5.59896 0.34375 5.48438L5.60938 0.21875C5.66667 0.166667 5.72656 0.125 5.78906 0.09375C5.85677 0.0625 5.92708 0.046875 6 0.046875C6.07292 0.046875 6.14062 0.0625 6.20312 0.09375C6.27083 0.125 6.33073 0.166667 6.38281 0.21875L11.6641 5.48438C11.7682 5.59896 11.8203 5.72656 11.8203 5.86719C11.8203 6.01302 11.7708 6.13542 11.6719 6.23438C11.5781 6.32812 11.4609 6.375 11.3203 6.375C11.2474 6.375 11.1771 6.36458 11.1094 6.34375C11.0469 6.31771 10.9922 6.28125 10.9453 6.23438L8.55469 3.86719L6.14844 1.28125L6.46094 1.17188L6.51562 3.28906V14.1641C6.51562 14.3151 6.46615 14.4375 6.36719 14.5312C6.27344 14.6302 6.15104 14.6797 6 14.6797Z"
      fill="var(--neutral-contrast-active)"
    />
  </svg>
);

export const RightArrowIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={fillClassName}
      d="M17.4111 7.63672C17.4111 7.95312 17.2969 8.22266 17.0684 8.44531L11.2939 14.2021C11.0654 14.4307 10.8105 14.5449 10.5293 14.5449C10.207 14.5449 9.94629 14.4453 9.74707 14.2461C9.54785 14.0469 9.44824 13.8008 9.44824 13.5078C9.44824 13.3438 9.47754 13.1973 9.53613 13.0684C9.60059 12.9395 9.68262 12.8252 9.78223 12.7256L11.751 10.7393L14.8711 7.8916L15.2754 8.55078L12.0762 8.73535H1.70508C1.37109 8.73535 1.10156 8.63574 0.896484 8.43652C0.691406 8.23145 0.588867 7.96484 0.588867 7.63672C0.588867 7.31445 0.691406 7.05371 0.896484 6.85449C1.10156 6.64941 1.37109 6.54688 1.70508 6.54688H12.0762L15.2754 6.72266L14.8711 7.39941L11.751 4.53418L9.78223 2.54785C9.68262 2.44824 9.60059 2.33398 9.53613 2.20508C9.47754 2.07031 9.44824 1.92383 9.44824 1.76562C9.44824 1.47266 9.54785 1.22656 9.74707 1.02734C9.94629 0.828125 10.207 0.728516 10.5293 0.728516C10.6641 0.728516 10.7959 0.757812 10.9248 0.816406C11.0596 0.869141 11.1885 0.957031 11.3115 1.08008L17.0684 6.82812C17.2969 7.05078 17.4111 7.32031 17.4111 7.63672Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// api error auth form
export const AttentionIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={fillClassName}
      d="M1.79492 11.3066C1.46289 11.3066 1.17773 11.2363 0.939453 11.0957C0.701172 10.9551 0.517578 10.7637 0.388672 10.5215C0.259766 10.2832 0.195312 10.0156 0.195312 9.71875C0.195312 9.43359 0.271484 9.16016 0.423828 8.89844L4.9707 0.976562C5.11914 0.710938 5.31641 0.511719 5.5625 0.378906C5.80859 0.242188 6.06641 0.173828 6.33594 0.173828C6.60547 0.173828 6.86133 0.242188 7.10352 0.378906C7.34961 0.511719 7.54883 0.710938 7.70117 0.976562L12.248 8.89844C12.3223 9.02734 12.3789 9.16211 12.418 9.30273C12.457 9.44336 12.4766 9.58203 12.4766 9.71875C12.4766 10.0156 12.4121 10.2832 12.2832 10.5215C12.1543 10.7637 11.9707 10.9551 11.7324 11.0957C11.4941 11.2363 11.209 11.3066 10.877 11.3066H1.79492ZM6.3418 7.38672C6.64648 7.38672 6.80078 7.22656 6.80469 6.90625L6.89258 3.71875C6.89648 3.56641 6.84375 3.43945 6.73438 3.33789C6.62891 3.23242 6.49609 3.17969 6.33594 3.17969C6.17188 3.17969 6.03711 3.23047 5.93164 3.33203C5.83008 3.43359 5.78125 3.56055 5.78516 3.71289L5.86133 6.90625C5.86914 7.22656 6.0293 7.38672 6.3418 7.38672ZM6.3418 9.34961C6.51758 9.34961 6.66992 9.28906 6.79883 9.16797C6.93164 9.04688 6.99805 8.89844 6.99805 8.72266C6.99805 8.54688 6.93164 8.39844 6.79883 8.27734C6.66992 8.15234 6.51758 8.08984 6.3418 8.08984C6.16211 8.08984 6.00781 8.15234 5.87891 8.27734C5.75 8.40234 5.68555 8.55078 5.68555 8.72266C5.68555 8.89844 5.75 9.04688 5.87891 9.16797C6.01172 9.28906 6.16602 9.34961 6.3418 9.34961Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// line divider
export const RhombIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0L0 5L5 10L10 5L5 0Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// mobile menu active nav link
export const LinesIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
  >
    <rect
      className={fillClassName}
      x="4"
      width="2"
      height="16"
      rx="1"
      fill="var(--neutral-active)"
    />
    <rect
      className={fillClassName}
      x="8"
      y="2"
      width="2"
      height="12"
      rx="1"
      fill="var(--neutral-active)"
    />
    <rect
      className={fillClassName}
      y="2"
      width="2"
      height="12"
      rx="1"
      fill="var(--neutral-active)"
    />
  </svg>
);

// social icons
export const FacebookIcon = ({
  mainClassName,
  fillClassName,
  backgroundClassName,
  strokeClassName,
}) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_71_17343)">
      <circle
        className={fillClassName}
        cx="20"
        cy="20"
        r="17"
        fill="var(--neutral-active)"
      />
      <path
        className={backgroundClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0C8.95407 0 0 8.95407 0 20C0 31.0459 8.95407 40 20 40C31.0459 40 40 31.0459 40 20C40 8.95407 31.0459 0 20 0ZM25.7185 12.8741H24.0326C22.3733 12.8741 21.8548 13.9052 21.8548 14.963V17.4696H25.5615L24.9689 21.3333H21.8548V30.6756H17.677V21.3333H14.2815V17.4696H17.677V14.5244C17.677 11.1733 19.6741 9.32444 22.7259 9.32444C24.1896 9.32444 25.7185 9.58518 25.7185 9.58518V12.8741Z"
        fill="var(--neutral-contrast-active)"
      />
    </g>
    <rect
      className={strokeClassName}
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="var(--neutral-active)"
    />
  </svg>
);

export const InstagramIcon = ({
  mainClassName,
  fillClassName,
  backgroundClassName,
  strokeClassName,
}) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_71_17346)">
      <circle
        className={fillClassName}
        cx="20"
        cy="20"
        r="17"
        fill="var(--neutral-active)"
      />
      <path
        className={backgroundClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20C0 8.95407 8.95407 0 20 0C31.0459 0 40 8.95407 40 20C40 31.0459 31.0459 40 20 40C8.95407 40 0 31.0459 0 20ZM28.0948 25.597C28.3052 25.0548 28.4504 24.4326 28.4919 23.523C28.5333 22.6104 28.5422 22.32 28.5422 20C28.5422 17.68 28.5333 17.3896 28.4919 16.477C28.4504 15.5674 28.3052 14.9452 28.0948 14.403C27.8756 13.84 27.5822 13.363 27.1081 12.8889C26.6311 12.4119 26.157 12.1215 25.5941 11.9022C25.0519 11.6919 24.4296 11.5467 23.52 11.5052C22.6074 11.4637 22.317 11.4548 19.997 11.4548C17.677 11.4548 17.3867 11.4637 16.4741 11.5052C15.5644 11.5467 14.9422 11.6919 14.4 11.9022C13.837 12.1215 13.36 12.4148 12.8859 12.8889C12.4089 13.3659 12.1185 13.84 11.8993 14.403C11.6889 14.9481 11.5437 15.5674 11.5022 16.477C11.4607 17.3896 11.4519 17.68 11.4519 20C11.4519 22.32 11.4607 22.6104 11.5022 23.523C11.5437 24.4326 11.6889 25.0548 11.8993 25.597C12.1185 26.16 12.4119 26.637 12.8859 27.1111C13.363 27.5881 13.837 27.8785 14.4 28.0978C14.9452 28.3081 15.5644 28.4533 16.4741 28.4948C17.3867 28.5363 17.677 28.5452 19.997 28.5452C22.317 28.5452 22.6074 28.5363 23.52 28.4948C24.4296 28.4533 25.0519 28.3081 25.5941 28.0978C26.157 27.8785 26.6341 27.5852 27.1081 27.1111C27.5852 26.6341 27.8756 26.16 28.0948 25.597ZM24.56 14.4148C23.9941 14.4148 23.5348 14.8741 23.5348 15.44C23.5348 16.0059 23.9941 16.4652 24.56 16.4652C25.1259 16.4652 25.5852 16.0059 25.5852 15.44C25.5852 14.8741 25.1259 14.4148 24.56 14.4148ZM20 16.6667C18.16 16.6667 16.6667 18.16 16.6667 20C16.6667 21.84 18.16 23.3333 20 23.3333C21.84 23.3333 23.3333 21.84 23.3333 20C23.3333 18.16 21.84 16.6667 20 16.6667Z"
        fill="var(--neutral-contrast-active)"
      />
    </g>
    <rect
      className={strokeClassName}
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="var(--neutral-active)"
    />
  </svg>
);

export const TwitterIcon = ({
  mainClassName,
  fillClassName,
  backgroundClassName,
  strokeClassName,
}) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_71_17349)">
      <circle
        className={fillClassName}
        cx="20"
        cy="20"
        r="17"
        fill="var(--neutral-active)"
      />
      <path
        className={backgroundClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0C8.95407 0 0 8.95407 0 20C0 31.0459 8.95407 40 20 40C31.0459 40 40 31.0459 40 20C40 8.95407 31.0459 0 20 0ZM24.0889 30.3319L18.5778 22.3111L11.677 30.3319H9.89333L17.7867 21.1585L9.89333 9.67111H15.9141L21.1348 17.2681L27.6711 9.67111H29.4548L21.9289 18.4207L30.1156 30.3319H24.0948H24.0889ZM20.9926 19.5022L27.6681 29.0489H24.9274L19.4815 21.2593L18.6815 20.1156L12.317 11.0133H15.0578L20.1926 18.3585L20.9926 19.5022Z"
        fill="var(--neutral-contrast-active)"
      />
    </g>
    <rect
      className={strokeClassName}
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="var(--neutral-active)"
    />
  </svg>
);

// card show more swiper gallery
export const CirclesIcon = ({
  mainClassName,
  fillClassName,
  strokeClassName,
}) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="180"
    height="180"
    viewBox="0 0 180 180"
    fill="none"
  >
    <circle className={fillClassName} cx="90" cy="90" r="90" fill="#FFD7E1" />
    <circle
      className={strokeClassName}
      cx="90"
      cy="90"
      r="19"
      stroke="#F59BB1"
      strokeWidth="18"
    />
  </svg>
);

export const GemsLogo = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M1 9.06964L10 17.9999L19 9.06964L14.5 6.11945H5.5L1 9.06964Z"
      stroke="var(--neutral-contrast-active)"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M1 9.06983L4.6 2L10 17.628L15.4 2L19 9.06983"
      stroke="var(--neutral-contrast-active)"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M1.45117 9.06964L9.75688 11.3022L18.5512 9.06964"
      stroke="var(--neutral-contrast-active)"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

// reader comment button
export const CommentIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.00390625 0.831848H14.0023V12.4442H7.26669L3.98074 15.7301V12.4442H0.00390625V0.831848ZM1.27649 2.10443V11.1716H5.25332V12.6578L6.73957 11.1716H12.7298V2.10443H1.27649ZM10.981 6.08124H3.02734V4.80865H10.981V6.08124ZM3.02734 8.46738H10.981V7.19479H3.02734V8.46738Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// reader quote icon
export const QuoteIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
  >
    <path
      className={fillClassName}
      d="M1.03681 24L0 22.88C4.06748 19.92 6.10123 16.68 6.10123 13.16C6.10123 10.2267 4.50613 7.69333 1.31595 5.56L6.89877 0C10.1687 2.42667 11.8037 5.29333 11.8037 8.6C11.8037 13.3467 8.21472 18.48 1.03681 24ZM15.2331 24L14.1963 22.88C18.2904 19.92 20.3374 16.68 20.3374 13.16C20.3374 10.2267 18.729 7.69333 15.5123 5.56L21.0951 0C24.365 2.42667 26 5.29333 26 8.6C26 13.3467 22.411 18.48 15.2331 24Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// reader dialogue icon
export const DialogueIcon = ({ mainClassName, fillClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="32"
    viewBox="0 0 16 32"
    fill="none"
  >
    <path
      className={fillClassName}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0C16 8.83656 8.83655 16 -1.39876e-06 16C8.83655 16 16 23.1634 16 32L16 0Z"
      fill="var(--neutral-active)"
    />
  </svg>
);

// desk && profile popup nav icons
export const ProfileIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      className={strokeClassName}
      cx="12"
      cy="12"
      r="10"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className={strokeClassName}
      d="M19.5 18.6319C17.4456 16.9851 14.8378 16 12 16C9.16216 16 6.5544 16.9851 4.5 18.6319"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className={strokeClassName}
      d="M7.75 10.3745L12.1245 6L16.499 10.3745L12.1245 14.749L7.75 10.3745Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const FavoritesIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M6.66667 3L4 20.4L11.3333 13.8L18 21L20 3H6.66667Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const HistoryIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M6 3H18V21H6V3Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className={strokeClassName}
      d="M22 5L22 19L18 19L18 5L22 5Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className={strokeClassName}
      d="M2 5L2 19L6 19L6 5L2 5Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const MyStoriesIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M10 6.41663C8.25 4.08329 5.33333 2.91663 3 2.91663V14.5833C3 14.5833 7.08333 15.75 10 18.0833V6.41663Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.6"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M10 6.41663C11.75 4.08329 14.6667 2.91663 17 2.91663V14.5833C17 14.5833 12.9167 15.75 10 18.0833V6.41663Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.6"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const StudioIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_135_1336)">
      <path
        className={strokeClassName}
        d="M15.3457 2.14148L21.899 8.69482L8.79236 21.8015H2.23901V15.2482L15.3457 2.14148Z"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className={strokeClassName}
        d="M9.74868 20.8449C9.18367 19.403 8.31865 18.0516 7.15363 16.8866C5.9886 15.7215 4.63717 14.8565 3.19533 14.2915"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className={strokeClassName}
        d="M12.8887 4.59901L19.442 11.1524"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export const BecomeCreatorIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_135_1163)">
      <path
        className={strokeClassName}
        d="M3 12L15 12"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        className={strokeClassName}
        d="M13.8281 9L16.6566 11.8284L13.8281 14.6569"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        className={strokeClassName}
        d="M12 1L21.5263 6.5V17.5L12 23L2.47372 17.5V6.5L12 1Z"
        stroke="var(--neutral-active)"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const LogoutIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M4.67188 16.5V2.5H18.6719V4.5M11.6719 18.5H18.6719V16"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      className={strokeClassName}
      d="M4.67188 4.22318C4.67188 3.45536 5.50136 2.97399 6.16801 3.35494L11.6719 6.5V21.5L4.67188 17.5V4.22318Z"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className={strokeClassName}
      d="M12.6719 10.5H18.1719"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      className={strokeClassName}
      d="M16.5 7.5L19.3284 10.3284L16.5 13.1569"
      stroke="var(--neutral-active)"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

// ai stories form buttons
export const PlayIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M8.9375 9.16809C8.93751 9.00588 8.98056 8.84658 9.06225 8.70645C9.14395 8.56631 9.26137 8.45037 9.40253 8.37045C9.54368 8.29053 9.70352 8.24949 9.86571 8.25154C10.0279 8.25358 10.1867 8.29863 10.3258 8.38208L13.379 10.214C13.5147 10.2955 13.627 10.4107 13.705 10.5484C13.783 10.6862 13.824 10.8417 13.824 11C13.824 11.1583 13.783 11.3139 13.705 11.4517C13.627 11.5894 13.5147 11.7046 13.379 11.786L10.3258 13.618C10.1867 13.7015 10.0279 13.7465 9.86571 13.7486C9.70351 13.7506 9.54367 13.7096 9.40251 13.6297C9.26135 13.5497 9.14393 13.4338 9.06224 13.2936C8.98054 13.1535 8.9375 12.9942 8.9375 12.832V9.16809Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SoundIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M15.125 9.16675V12.8334"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M17.875 7.33337V14.6667"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M6.75781 7.90628H4.58073C4.07473 7.90628 3.66406 8.31695 3.66406 8.82295V13.1771C3.66406 13.6831 4.07473 14.0938 4.58073 14.0938H6.75781L10.4052 17.1839C11.0011 17.689 11.9141 17.2655 11.9141 16.4845V5.51562C11.9141 4.73462 11.0001 4.31112 10.4052 4.8162L6.75781 7.90628Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M16.4418 8.66663H10.2196C9.36051 8.66663 8.66406 9.36307 8.66406 10.2222V16.4444C8.66406 17.3035 9.36051 18 10.2196 18H16.4418C17.3009 18 17.9974 17.3035 17.9974 16.4444V10.2222C17.9974 9.36307 17.3009 8.66663 16.4418 8.66663Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M6.33333 13.3333H5.55556C5.143 13.3333 4.74733 13.1694 4.45561 12.8777C4.16389 12.586 4 12.1903 4 11.7778V5.55556C4 5.143 4.16389 4.74733 4.45561 4.45561C4.74733 4.16389 5.143 4 5.55556 4H11.7778C12.1903 4 12.586 4.16389 12.8777 4.45561C13.1694 4.74733 13.3333 5.143 13.3333 5.55556V6.33333"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({ mainClassName, strokeClassName }) => (
  <svg
    className={mainClassName}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      className={strokeClassName}
      d="M4.5817 10.3174L3.37537 8.95709C3.24772 8.81314 3.1686 8.63268 3.14921 8.44126C3.12983 8.24985 3.17116 8.05718 3.26736 7.89057L4.43997 5.85945C4.53616 5.69284 4.68234 5.56071 4.8578 5.48179C5.03326 5.40287 5.2291 5.38116 5.41758 5.41973L7.19893 5.78422L8.38114 5.10164L8.9561 3.37679C9.01694 3.19427 9.13367 3.03552 9.28974 2.92303C9.44582 2.81053 9.63333 2.75 9.82572 2.75H12.171C12.3634 2.75 12.5509 2.81053 12.707 2.92303C12.8631 3.03552 12.9798 3.19427 13.0406 3.37679L13.6156 5.10164L14.7978 5.78422L16.5792 5.41973C16.7676 5.38116 16.9635 5.40287 17.1389 5.48179C17.3144 5.56071 17.4606 5.69284 17.5568 5.85945L18.7294 7.89053C18.8256 8.05715 18.8669 8.24981 18.8475 8.44123C18.8281 8.63265 18.749 8.81311 18.6214 8.95705L17.415 10.3174V11.6826L18.6214 13.0429C18.749 13.1869 18.8281 13.3673 18.8475 13.5587C18.8669 13.7502 18.8256 13.9428 18.7294 14.1094L17.5567 16.1405C17.4606 16.3071 17.3144 16.4393 17.1389 16.5182C16.9635 16.5971 16.7676 16.6188 16.5791 16.5802L14.7977 16.2157L13.6156 16.8982L13.0406 18.6232C12.9798 18.8057 12.8631 18.9644 12.707 19.0769C12.5509 19.1894 12.3634 19.25 12.171 19.25H9.82573C9.63334 19.25 9.44583 19.1895 9.28975 19.077C9.13367 18.9645 9.01695 18.8057 8.95611 18.6232L8.38114 16.8982L7.19899 16.2158L5.41758 16.5803C5.22909 16.6188 5.03325 16.5971 4.8578 16.5182C4.68234 16.4393 4.53616 16.3072 4.43997 16.1405L3.26733 14.1095C3.17114 13.9428 3.12981 13.7502 3.1492 13.5588C3.16859 13.3674 3.24772 13.1869 3.37537 13.0429L4.5817 11.6826V10.3174Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className={strokeClassName}
      d="M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z"
      stroke="var(--neutral-active)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
